module.exports = __webpack_public_path__ + "img/img_4.6155ae46.png";